/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AllShipmentsCalendarStats
 */
export interface AllShipmentsCalendarStats {
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCalendarStats
   */
  totalQuoted: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCalendarStats
   */
  totalBooked: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCalendarStats
   */
  totalRevenue: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCalendarStats
   */
  avgDailyQuoted: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCalendarStats
   */
  avgDailyBooked: number;
  /**
   *
   * @type {LocalDate}
   * @memberof AllShipmentsCalendarStats
   */
  busiestDay?: LocalDate | null;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCalendarStats
   */
  busiestDayCount: number;
}

/**
 * Check if a given object implements the AllShipmentsCalendarStats interface.
 */
export function instanceOfAllShipmentsCalendarStats(
  value: object,
): value is AllShipmentsCalendarStats {
  if (!("totalQuoted" in value) || value["totalQuoted"] === undefined)
    return false;
  if (!("totalBooked" in value) || value["totalBooked"] === undefined)
    return false;
  if (!("totalRevenue" in value) || value["totalRevenue"] === undefined)
    return false;
  if (!("avgDailyQuoted" in value) || value["avgDailyQuoted"] === undefined)
    return false;
  if (!("avgDailyBooked" in value) || value["avgDailyBooked"] === undefined)
    return false;
  if (!("busiestDayCount" in value) || value["busiestDayCount"] === undefined)
    return false;
  return true;
}

export function AllShipmentsCalendarStatsFromJSON(
  json: any,
): AllShipmentsCalendarStats {
  return AllShipmentsCalendarStatsFromJSONTyped(json, false);
}

export function AllShipmentsCalendarStatsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsCalendarStats {
  if (json == null) {
    return json;
  }
  return {
    totalQuoted: json["totalQuoted"],
    totalBooked: json["totalBooked"],
    totalRevenue: json["totalRevenue"],
    avgDailyQuoted: json["avgDailyQuoted"],
    avgDailyBooked: json["avgDailyBooked"],
    busiestDay: json["busiestDay"] == null ? undefined : json["busiestDay"],
    busiestDayCount: json["busiestDayCount"],
  };
}

export function AllShipmentsCalendarStatsToJSON(
  json: any,
): AllShipmentsCalendarStats {
  return AllShipmentsCalendarStatsToJSONTyped(json, false);
}

export function AllShipmentsCalendarStatsToJSONTyped(
  value?: AllShipmentsCalendarStats | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    totalQuoted: value["totalQuoted"],
    totalBooked: value["totalBooked"],
    totalRevenue: value["totalRevenue"],
    avgDailyQuoted: value["avgDailyQuoted"],
    avgDailyBooked: value["avgDailyBooked"],
    busiestDay: value["busiestDay"],
    busiestDayCount: value["busiestDayCount"],
  };
}
